import { createEvent, restore, sample } from 'effector'
import { fx } from '../../../../libs'
import { InternalTransfer } from './types'
import { $params } from '../../../../features/router'

export const internalTransferMounted = createEvent()
export const setInternalTransfer = createEvent<InternalTransfer>()
export const $internalTransfer = restore(setInternalTransfer, {
  transactionId: '',
  client: {
    clientId: '',
    email: '',
    fullName: '',
    partner: false,
  },
  isAuto: false,
  processingProvider: '',
  processingMethod: '',
  status: '',
  initialAmount: '',
  initialCurrency: '',
  clientAmount: '',
  companyAmount: '',
  exchangeRate: '',
  clientCurrency: '',
  clientCommission: '',
  companyCommission: '',
  commissionCurrency: '',
  createdAt: '',
  updatedAt: '',
  externalId: '',
  providerId: '',
  psId: '',
  clientPurseId: '',
  manager: {
    userId: '',
  },
})

export const getInternalTransfer = fx<void, InternalTransfer>({
  method: 'GET',
  url: '/transaction_request/',
})

sample({
  clock: internalTransferMounted,
  source: $params,
  fn: (params) => {
    let id
    if (params) {
      id = params.internalTransferID
    }
    return {
      url: `/transaction_request/${id}`,
    }
  },
  target: getInternalTransfer,
})

sample({
  clock: getInternalTransfer.doneData,
  fn: (doneData) => doneData.body,
  target: setInternalTransfer,
})
